module.exports = __webpack_public_path__ + "img/3rd-grade-en.b8a14bb0.png";